var _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.923884 0H19.4016C19.9118 0 20.3254 0.413654 20.3254 0.923884V13.8583C20.3254 14.3685 19.9118 14.7821 19.4016 14.7821H0.923884C0.413654 14.7821 0 14.3685 0 13.8583V0.923884C0 0.413654 0.413654 0 0.923884 0ZM1.85156 12.9382H18.4815V1.85156H1.85156V12.9382Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.88606,
    cy: 5.63801,
    r: 2.2552,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89861 7.875C4.96123 7.875 3.39062 9.44548 3.39062 11.383H10.4066C10.4066 9.44548 8.836 7.875 6.89861 7.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8399 6.15246H15.6996C16.2099 6.15246 16.6235 5.7388 16.6235 5.22857C16.6235 4.71834 16.2099 4.30469 15.6996 4.30469H12.8399C12.3297 4.30469 11.916 4.71834 11.916 5.22857C11.916 5.7388 12.3297 6.15246 12.8399 6.15246Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8399 10.4728H15.6996C16.2099 10.4728 16.6235 10.0591 16.6235 9.54888C16.6235 9.03865 16.2099 8.625 15.6996 8.625H12.8399C12.3297 8.625 11.916 9.03865 11.916 9.54888C11.916 10.0591 12.3297 10.4728 12.8399 10.4728Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.0ea63dc7fc92f95de414e9686dadae97.svg";
export { ForwardRef as ReactComponent };